export default __webpack_public_path__ + "static/media/Background.e5a51709.png";